import {combine, sample} from 'effector';

import {
    $breadcrumbs,
    $childrenCache,
    $currentCode,
    $currentLevelData,
    fetchChildrenFx,
    navigateBack,
    navigateToChildren,
    resetNavigation,
    setCurrentLevelData,
} from './index';

$breadcrumbs
    .on(navigateToChildren, (state, payload) => [...state, payload])
    .reset(resetNavigation)
    .on(navigateBack, (state, index) => state.slice(0, index + 1));

$childrenCache.on(fetchChildrenFx.done, (state, {params, result}) => ({
    ...state,
    [params.aggregationNumber]: result,
}));

$currentLevelData
    .on(fetchChildrenFx.doneData, (_, payload) => payload)
    .on(setCurrentLevelData, (state, payload) => payload ?? state)
    .reset(resetNavigation);

$currentCode
    .on(navigateToChildren, (_, payload) => payload.identityCode)
    .on(navigateBack, (state) => {
        const breadcrumbs = $breadcrumbs.getState();
        const last = breadcrumbs?.[breadcrumbs.length - 1];
        return last?.identityCode ?? state;
    })
    .reset(resetNavigation);

sample({
    clock: navigateToChildren,
    fn: (payload) => ({
        aggregationNumber: payload.identityCode,
        gtin: payload.gtin,
    }),
    target: fetchChildrenFx,
});

sample({
    clock: navigateBack,
    source: combine({breadcrumbs: $breadcrumbs, cache: $childrenCache}),
    fn: ({breadcrumbs, cache}) => {
        const last = breadcrumbs[breadcrumbs.length - 1]?.identityCode;
        if (!last) return null;
        return cache[last] ?? null;
    },
    target: setCurrentLevelData,
});
